import React, { useContext } from 'react';

import AsideBox from 'Components/common/AsideBox';
import { ContentContext } from 'Components/hooks/context';
import FlatteningCurve from './FlatteningCurve';
import HeadlineNews from './HeadlineNews';
import LocaleLinks from './LocaleLinks';
import MethodologyLink from 'Components/common/MethodologyLink';
import RateMap from './RateMap';
import RegionShare from './RegionShare';
import ReutersReferrals from 'Components/common/ReutersReferrals';
import TopDailyCounts from './TopDailyCounts';
import TopDailyHeadline from './TopDailyHeadline';
import Vaccination from './Vaccination';

const PageContent = (props) => {
  const { globalCounts, regionalCounts, globalStatistics, hasFetched, locales } = props;

  const content = useContext(ContentContext);

  return (
    <article>
      <section>
        <LocaleLinks locales={locales} />
      </section>
      <section className='wide'>
        <HeadlineNews
          globalStatistics={globalStatistics}
          hasFetched={hasFetched}
        />
      </section>
      <div className='section-spacer' />
      <section className='wide'>
        <AsideBox
          title={content.common.about.title}
          source={content.common.about.smarttext}
          context={{ countries: Object.keys(globalStatistics.latestTotals.cases).length }}
        >
          <p className='readmore-link'><MethodologyLink>{content.common.about.methodologyLink}</MethodologyLink></p>
        </AsideBox>
      </section>
      <section>
        <TopDailyHeadline
          globalStatistics={globalStatistics}
          globalCounts={globalCounts}
        />
        <TopDailyCounts
          globalStatistics={globalStatistics}
          counts={globalCounts}
        />
        <div className='section-spacer' />
        <Vaccination />
        <div className='section-spacer' />
        <FlatteningCurve globalStatistics={globalStatistics} />
      </section>
      <div className='section-spacer' />
      <div className='section-spacer-internal' />
      <div className='container-fluid map-container'>
        <div className='row'>
          <div className='col-12 px-0'>
            <RateMap globalStatistics={globalStatistics} />
          </div>
        </div>
      </div>
      <section className=''>
        <div className='col-12 col-lg-10 mx-auto px-0'>
          <ReutersReferrals />
        </div>
      </section>
      <section>
        <RegionShare
          counts={regionalCounts}
          endDates={globalStatistics.latestCompletedCounts}
        />
        <div className='section-spacer-internal' />
      </section>
    </article>
  );
};

export default PageContent;
